'use strict';

angular.module('controllers').controller('simpleViewAppCtrl', ["$scope", function ($scope) {

	}]);